import { LuCircuitBoard, LuHeartHandshake, LuPackageCheck } from "react-icons/lu";
import styles from "./styles.module.css"

function StepByStep(){
    return(
        <section className={styles.stepbystep}>
            <div className={styles.step}>
                <LuCircuitBoard className={styles.stepIcon} />
                <div className={styles.stepTitle}>1. Simulação</div>
                <div className={styles.stepDescription}>Os valores da simulação serão a base do seu consórcio.</div>
            </div>
            <div className={styles.step}>
                <LuHeartHandshake className={styles.stepIcon}/>
                <div className={styles.stepTitle}>2. Fechar o negócio</div>
                <div className={styles.stepDescription}>Você tem uma assessoria exclusiva para orientá-lo durante todo o processo.</div>
            </div>
            <div className={styles.step}>
                <LuPackageCheck className={styles.stepIcon} />
                <div className={styles.stepTitle}>3. Pronto!</div>
                <div className={styles.stepDescription}>Agora é só esperar seu bem ser contemplado.</div>
            </div>
        </section>
    )
}

export default StepByStep